import { ABTestingContextProvider } from '@/contexts/abtesting-context/abtesting-context'
import { ConfigurationContextProvider } from '@/contexts/configuration-context/configuration-context'
import { ErrorContextProvider } from '@/contexts/error-context/error-context'
import { FeatureFlagsProvider } from '@/contexts/feature-flags-context/feature-flags-context'
import { MarketContextProvider } from '@/contexts/market-context/market-context'
import { ModalContextProvider } from '@/contexts/modal-context/modal-context'
import { TurnstileProvider } from '@/contexts/turnstile-context/turnstile-context'
import { BuybackMarkets } from '@/features/circular/buyback'
import { StoresProvider } from '@/features/stores/stores-context'
import { ConfigurationData, StoreData } from '@/types'

import { CircularContextProvider } from '../circular-context/circular-context'

interface AppContextProviderProps {
  country_code: string
  language_code: string
  children?: React.ReactNode
  configuration: ConfigurationData[]
  ikeaScriptUrls: string[]
  optimizelySdkKey: string
  stores: StoreData[]
  buybackMarkets: BuybackMarkets
}

export const AppContextProvider: React.FC<AppContextProviderProps> = ({
  children,
  configuration = [],
  country_code = '',
  language_code = '',
  ikeaScriptUrls,
  optimizelySdkKey,
  stores,
  buybackMarkets,
}) => {
  return (
    <ABTestingContextProvider
      ikeaScriptUrls={ikeaScriptUrls}
      sdkKey={optimizelySdkKey}
    >
      <MarketContextProvider value={{ country_code, language_code }}>
        <ConfigurationContextProvider values={configuration}>
          <FeatureFlagsProvider>
            <ErrorContextProvider>
              <ModalContextProvider>
                <CircularContextProvider value={{ buybackMarkets }}>
                  <StoresProvider stores={stores}>
                    <TurnstileProvider>{children}</TurnstileProvider>
                  </StoresProvider>
                </CircularContextProvider>
              </ModalContextProvider>
            </ErrorContextProvider>
          </FeatureFlagsProvider>
        </ConfigurationContextProvider>
      </MarketContextProvider>
    </ABTestingContextProvider>
  )
}
